import { Grid } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import UniversalToolBarWithDialogs from "../../components/bar/UniversalToolBarWithDialogs";
import FilterTable from "../../components/table/FilterTable";
import LoaderWrapper from "../../components/wrapper/LoaderWrapper";
import usePaginationWithSearchParams from "../../hooks/usePaginationWithSearchParams";
import TableService from "../../services/tableService";
import { useGetTasksForUser } from "../../services/taskService";
import { TODO_TASKS_TABLE_NAME, useTodoTasksTableFieldsConfig } from "./TodoTasksTableConfig";

export function TodoTaskTable({ userId }) {
    const { t } = useTranslation();

    const [dataLocal, setDataLocal] = useState([]);

    const [hasEditPermission] = [true];
    const [selectedRowId, setSelectedRowId] = useState();
    const [hiddenColumnsForTables, setHiddenColumnsForTables] = useState([]);
    const [columnsOrdersForTables, setColumnsOrdersForTables] = useState([]);
    const [checkedAll, setCheckedAll] = useState(false);
    const [tableLoading] = useState(false);

    const todoTableFieldsConfig = useTodoTasksTableFieldsConfig();

    // @ts-ignore
    const onClickButton = useCallback((e, id) => {
        e.stopPropagation();
    }, []);

    const {
        resetPageNumber,
        searchParams,
        setSearchParams,
        page: dataPage,
        pageSize: dataPageSize,
        handleChangePageWithSearchParams: handleChangeDataPage,
        handleChangePageSizeWithSearchParams: handleChangeDataPageSize,
    } = usePaginationWithSearchParams();

    // Add todo filter to search params
    const todoSearchParams = new URLSearchParams(searchParams);
    todoSearchParams.set('todo', 'true');

    const { data: tasks, refetch } = useGetTasksForUser(userId, null, null, todoSearchParams);

    useEffect(() => {
        setDataLocal(tasks || []);
    }, [tasks, dataPage, dataPageSize]);

    useEffect(() => {
        refetch();
    }, [searchParams, refetch]);

    const data = useMemo(
        () =>
            TableService.getPreparedDataForCollapsibleTable(
                todoTableFieldsConfig,
                dataLocal, // @ts-ignore
                hiddenColumnsForTables?.[TODO_TASKS_TABLE_NAME]
                    ? // @ts-ignore
                      hiddenColumnsForTables?.[TODO_TASKS_TABLE_NAME]
                    : [], // @ts-ignore
                columnsOrdersForTables?.[TODO_TASKS_TABLE_NAME]
                    ? // @ts-ignore
                      columnsOrdersForTables?.[TODO_TASKS_TABLE_NAME]
                    : [],
                onClickButton,
            ),
        [
            todoTableFieldsConfig,
            dataLocal,
            hiddenColumnsForTables,
            columnsOrdersForTables,
            onClickButton,
        ],
    );

    return (
        // @ts-ignore
        <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            rowSpacing={1}
        >
            <Grid item xs={12} marginY={1}>
                <UniversalToolBarWithDialogs
                    tableConfig={{
                        name: TODO_TASKS_TABLE_NAME,
                        config: todoTableFieldsConfig,
                    }}
                    filteringData={() => {}}
                    refreshTable={refetch}
                    // @ts-ignore
                    resetPageNumber={resetPageNumber}
                    // @ts-ignore
                    hiddenColumnsForTables={hiddenColumnsForTables}
                    setHiddenColumnsForTables={setHiddenColumnsForTables}
                    columnsOrdersForTables={columnsOrdersForTables}
                    setColumnsOrdersForTables={setColumnsOrdersForTables}
                    showMassActionButton={false}
                    showOpenCloseFilterButton={false}
                    showCleanfiltersButton={true}
                    showMyFiltersButton={false}
                    showSearchButton={false}
                    itemType={"task"}
                    style={{ marginBlock: "5px" }}
                    mdGridButton={hasEditPermission ? 3 : 2.75}
                    showImportList={false}
                    showRemoveLeadButton={false}
                />
            </Grid>
            <Grid item xs={12}>
                <LoaderWrapper showLoader={false}>
                    <FilterTable
                        // @ts-ignore
                        data={data}
                        selectedItemId={selectedRowId}
                        style={{ maxHeight: "100vh" }}
                        headersConfig={TableService.orderColumns(
                            TableService.hideHiddenColumns(
                                todoTableFieldsConfig, // @ts-ignore
                                hiddenColumnsForTables?.[TODO_TASKS_TABLE_NAME]
                                    ? // @ts-ignore
                                      hiddenColumnsForTables?.[TODO_TASKS_TABLE_NAME]
                                    : [],
                            ), // @ts-ignore
                            columnsOrdersForTables?.[TODO_TASKS_TABLE_NAME]
                                ? // @ts-ignore
                                  columnsOrdersForTables?.[TODO_TASKS_TABLE_NAME]
                                : [],
                        )}
                        showCleanFilterIcon={true}
                        showContextMenu={false}
                        showExportToFileButton={false}
                        showDetailsIcon={false}
                        showCheckbox={false}
                        checkedAll={checkedAll}
                        setDataLocal={setDataLocal}
                        setCheckedAll={setCheckedAll}
                        setSelectedRowId={setSelectedRowId}
                        isLoading={tableLoading}
                        showCounterRecords={false}
                        withPagination={true}
                        page={dataPage}
                        onPageChange={handleChangeDataPage}
                        rowsPerPage={dataPageSize}
                        resetPageNumber={resetPageNumber}
                        onRowsPerPageChange={handleChangeDataPageSize}
                        hideFiltersIconCol={false}
                    />
                </LoaderWrapper>
            </Grid>
        </Grid>
    );
}
